import StoredLayout from '../../layouts/StoredLayout'
import Breadcrumbs from './Breadcrumbs'
export default StoredLayout(Breadcrumbs)



// WEBPACK FOOTER //
// ./src/ui-elements/breadcrumbs/index.js